import { render, staticRenderFns } from "./AddMembershipPackage.vue?vue&type=template&id=48192fc0&scoped=true"
import script from "./AddMembershipPackage.vue?vue&type=script&lang=js"
export * from "./AddMembershipPackage.vue?vue&type=script&lang=js"
import style0 from "./AddMembershipPackage.vue?vue&type=style&index=0&id=48192fc0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48192fc0",
  null
  
)

export default component.exports